export default "__VITE_ASSET__B4s8nKjH__"